/* facets.js — collection filtering/sorting via the Section Rendering API + load-more */
(function () {
  'use strict';

  const root = () => document.querySelector('[data-collection-root]');
  if (!root()) return;

  let debounceTimer = null;

  function serialize(form) {
    const params = new URLSearchParams();
    form.querySelectorAll('input[type="checkbox"]:checked').forEach((i) => params.append(i.name, i.value));
    form.querySelectorAll('input[type="number"]').forEach((i) => {
      if (i.value !== '') params.append(i.name, i.value);
    });
    const sort = form.querySelector('input[data-sort]:checked');
    if (sort && sort.value) params.append('sort_by', sort.value);
    return params;
  }

  function fetchAndReplace(url) {
    const container = root();
    const sectionId = container.getAttribute('data-section-id');
    container.classList.add('is-loading');
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    fetch(fetchUrl.toString())
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-collection-root]');
        if (fresh) {
          container.replaceWith(fresh);
          bind();
        }
        window.history.pushState({}, '', url);
      })
      .finally(() => {
        const c = root();
        if (c) c.classList.remove('is-loading');
      });
  }

  function applyFilters() {
    const form = document.querySelector('[data-facets-form]');
    if (!form) return;
    const params = serialize(form);
    const url = `${window.location.pathname}?${params.toString()}`;
    fetchAndReplace(url);
  }

  function bind() {
    const container = root();
    if (!container) return;

    // close the mobile filter panel by default on small screens
    const details = container.querySelector('[data-filters-details]');
    if (details && window.matchMedia('(max-width: 989px)').matches) {
      details.removeAttribute('open');
    }

    container.querySelectorAll('[data-facets-form] input[type="checkbox"], input[data-sort]').forEach((el) => {
      el.addEventListener('change', applyFilters);
    });
    container.querySelectorAll('[data-facets-form] input[type="number"]').forEach((el) => {
      el.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(applyFilters, 600);
      });
    });

    const form = container.querySelector('[data-facets-form]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        applyFilters();
      });
    }

    const loadMore = container.querySelector('[data-load-more]');
    if (loadMore) {
      loadMore.addEventListener('click', (e) => {
        e.preventDefault();
        const url = new URL(loadMore.href, window.location.origin);
        const sectionId = container.getAttribute('data-section-id');
        url.searchParams.set('section_id', sectionId);
        loadMore.setAttribute('aria-busy', 'true');

        fetch(url.toString())
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newItems = doc.querySelector('[data-grid-items]');
            const newPagination = doc.querySelector('[data-pagination]');
            const grid = container.querySelector('[data-grid-items]');
            const pagination = container.querySelector('[data-pagination]');
            if (newItems && grid) {
              Array.from(newItems.children).forEach((li) => grid.appendChild(li));
            }
            if (pagination && newPagination) {
              pagination.replaceWith(newPagination);
            }
            bindLoadMoreOnly();
          });
      });
    }
  }

  function bindLoadMoreOnly() {
    const container = root();
    if (!container) return;
    const loadMore = container.querySelector('[data-load-more]');
    if (loadMore && !loadMore.__bound) {
      loadMore.__bound = true;
      loadMore.addEventListener('click', (e) => {
        e.preventDefault();
        const url = new URL(loadMore.href, window.location.origin);
        url.searchParams.set('section_id', container.getAttribute('data-section-id'));
        fetch(url.toString())
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newItems = doc.querySelector('[data-grid-items]');
            const newPagination = doc.querySelector('[data-pagination]');
            const grid = container.querySelector('[data-grid-items]');
            const pagination = container.querySelector('[data-pagination]');
            if (newItems && grid) Array.from(newItems.children).forEach((li) => grid.appendChild(li));
            if (pagination && newPagination) pagination.replaceWith(newPagination);
            bindLoadMoreOnly();
          });
      });
    }
  }

  window.addEventListener('popstate', () => window.location.reload());

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
